import Navbar from "../../components/Navbar";
import Pricing from "../../components/Pricing";
import FAQ from "../../components/FAQ";
import GetStarted from "../../components/GetStarted";
import Footer from "../../components/Footer";

const _Pricing = () => {
    return (
        <>
            <Navbar/>
            <Pricing/>
            <FAQ/>
            <GetStarted/>
            <Footer/>
        </>
    )
}

export default _Pricing;